import './home.css'
import wwwwoohooo from './assets/home/wwwwoohooo.png'

import rankytanktitle from './assets/home/rankytanktitle.png'
import husholdtitle from './assets/home/husholdtitle.png'
import teksturtitle from './assets/home/teksturtitle.png'
import itimertootitle from './assets/home/itimertootitle.png'

import rankytanklogo from './assets/home/wwwrankytank30pct.png'
import husholdlogo from './assets/home/husholdlogolarge2.png'
import teksturlogo from './assets/home/tekstur1337.png'
import itimertoologo from './assets/home/itimertoo307.png'

import Footer from './footer'

function Home() {
  return (
    <div className="page">
      <div className="main_page">
        <img className="woohooologo" src={wwwwoohooo} />
      </div>

      <div className="main_page" style={{ paddingBottom: 10, display: 'flex', flexDirection: 'column' }}>
        <div
          className="main_container"
          style={{
            display: 'flex',
            flex: 1,
            width: '100%',
            marginTop: '1vw',
            boxSizing: 'border-box',
            gap: 20,
            paddingLeft: 16,
            paddingRight: 16,
          }}
        >
          <div style={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
            <a href="/rankytank">
              <div className="rankytanktitleouter">
                <img className="rankytanktitle" src={rankytanktitle} />
              </div>
            </a>
            <div style={{ display: 'flex', flex: 1, justifyContent: 'center' }}>
              <div className="rankytanksubtitle">..for handling statistics for table soccer, padel, tennis, badminton and ping pong.</div>
            </div>
            <a href="/rankytank">
              <img className="rankytanklogo" src={rankytanklogo} />
            </a>
          </div>
          <div style={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
            <a href="/hushold">
              <div className="husholdtitleouter">
                <img className="husholdtitle" src={husholdtitle} />
              </div>
            </a>
            <div style={{ display: 'flex', flex: 1, justifyContent: 'center' }}>
              <div className="rankytanksubtitle">..danish app, to organize shopping lists etc — because running out of toilet paper is never fun.</div>
            </div>
            <a href="/hushold">
              <img className="rankytanklogo" src={husholdlogo} />
            </a>
          </div>
          <div style={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
            <a href="/tekstur">
              <div className="teksturtitleouter">
                <img className="teksturtitle" src={teksturtitle} />
              </div>
            </a>
            <div style={{ display: 'flex', flex: 1, justifyContent: 'center' }}>
              <div className="rankytanksubtitle">..danish app, that could teach kids on how the tell the clock.</div>
            </div>
            <a href="/tekstur">
              <img className="rankytanklogo" src={teksturlogo} />
            </a>
          </div>
          {/* <div style={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
            <a href="/itimertoo">
              <img className="itimertootitle" src={itimertootitle} />
            </a>
            <div style={{ display: 'flex', flex: 1, justifyContent: 'center' }}>
              <div className="rankytanksubtitle">..for handling multiple timers, events etc.</div>
            </div>
            <a href="/itimertoo">
              <img className="rankytanklogo" src={itimertoologo} />
            </a>
          </div> */}
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default Home
